import { ApiEpBilling } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.billing.plan_product.set";

export const useQueryBillingPlanProductSet = (
  params?: NonNullable<
    Parameters<typeof ApiEpBilling.Product.PlanProduct.list>[0]
  >["query"],
  options?: Omit<
    UseQueryOptions<
      Await<ReturnType<typeof ApiEpBilling.Product.PlanProduct.list>>
    >,
    "queryKey" | "queryFn"
  >,
) =>
  useQuery<Await<ReturnType<typeof ApiEpBilling.Product.PlanProduct.list>>>(
    [KEY, params],
    () =>
      ApiEpBilling.Product.PlanProduct.list(
        params ? { query: params } : undefined,
      ),
    options,
  );

useQueryBillingPlanProductSet.KEY = KEY;
